(function () {
  'use strict';

  const theme = window.KCTheme || {};
  const root = (theme.root || '/').replace(/\/?$/, '/');

  function formatMoney(cents) {
    const value = Number(cents || 0);
    const format = theme.moneyFormat || '${{amount}}';
    const token = format.match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?)\s*\}\}/);
    if (!token) return (value / 100).toFixed(2);
    let amount;
    if (token[1] === 'amount_no_decimals') amount = Math.round(value / 100).toLocaleString('en-US');
    else if (token[1] === 'amount_with_comma_separator') amount = (value / 100).toFixed(2).replace('.', ',');
    else if (token[1] === 'amount_no_decimals_with_comma_separator') amount = Math.round(value / 100).toString();
    else amount = (value / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return format.replace(token[0], amount);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (banner, index) {
      const duration = Number(banner.dataset.duration || 14400);
      const key = 'kc-countdown-' + index + '-' + duration;
      let end = Number(sessionStorage.getItem(key));
      if (!end || end <= Date.now()) {
        end = Date.now() + duration * 1000;
        sessionStorage.setItem(key, String(end));
      }
      const output = banner.querySelector('[data-countdown-value]');
      const tick = function () {
        let seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (seconds <= 0) {
          end = Date.now() + duration * 1000;
          sessionStorage.setItem(key, String(end));
          seconds = duration;
        }
        const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
        const remaining = String(seconds % 60).padStart(2, '0');
        if (output) output.textContent = hours + ':' + minutes + ':' + remaining;
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      const stage = gallery.querySelector('[data-gallery-stage]');
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const counter = gallery.querySelector('[data-gallery-current]');
      let activeIndex = Math.max(0, thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); }));
      let startX = null;
      let startY = null;
      let dragX = 0;

      function showImage(nextIndex) {
        if (!main || !thumbs.length) return;
        const normalizedIndex = (nextIndex + thumbs.length) % thumbs.length;
        const thumb = thumbs[normalizedIndex];
        if (!thumb || !thumb.dataset.full) return;
        const direction = normalizedIndex === activeIndex ? 0 : (normalizedIndex > activeIndex ? 1 : -1);
        activeIndex = normalizedIndex;
        thumbs.forEach(function (item, index) {
          const selected = index === activeIndex;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (counter) counter.textContent = String(activeIndex + 1);
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        main.classList.add('is-changing');
        main.style.transform = 'translateX(' + (direction > 0 ? '-4%' : direction < 0 ? '4%' : '0') + ')';
        const preload = new Image();
        preload.onload = function () {
          main.src = thumb.dataset.full;
          main.classList.remove('is-changing');
          requestAnimationFrame(function () { main.style.transform = 'translateX(0)'; });
        };
        preload.onerror = function () {
          main.classList.remove('is-changing');
          main.style.transform = 'translateX(0)';
        };
        preload.src = thumb.dataset.full;
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          if (index !== activeIndex) showImage(index);
        });
      });

      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      if (previous) previous.addEventListener('click', function () { showImage(activeIndex - 1); });
      if (next) next.addEventListener('click', function () { showImage(activeIndex + 1); });

      if (stage && thumbs.length > 1) {
        stage.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') { event.preventDefault(); showImage(activeIndex - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); showImage(activeIndex + 1); }
        });
        stage.addEventListener('pointerdown', function (event) {
          if (event.target.closest('button') || (event.pointerType === 'mouse' && event.button !== 0)) return;
          startX = event.clientX;
          startY = event.clientY;
          dragX = 0;
          stage.classList.add('is-dragging');
          if (stage.setPointerCapture) stage.setPointerCapture(event.pointerId);
        });
        stage.addEventListener('pointermove', function (event) {
          if (startX === null) return;
          dragX = event.clientX - startX;
          const dragY = event.clientY - startY;
          if (Math.abs(dragX) > Math.abs(dragY) && main) {
            main.style.transition = 'none';
            main.style.transform = 'translateX(' + (dragX * 0.24) + 'px) scale(.985)';
          }
        });
        const finishSwipe = function (event) {
          if (startX === null) return;
          const dragY = event.clientY - startY;
          stage.classList.remove('is-dragging');
          if (main) {
            main.style.transition = '';
            main.style.transform = 'translateX(0)';
          }
          if (Math.abs(dragX) > 45 && Math.abs(dragX) > Math.abs(dragY)) showImage(activeIndex + (dragX < 0 ? 1 : -1));
          startX = null;
          startY = null;
          dragX = 0;
        };
        stage.addEventListener('pointerup', finishSwipe);
        stage.addEventListener('pointercancel', finishSwipe);
      }

      if (thumbs.length > 1) {
        const nextThumb = thumbs[(activeIndex + 1) % thumbs.length];
        const previousThumb = thumbs[(activeIndex - 1 + thumbs.length) % thumbs.length];
        [nextThumb, previousThumb].forEach(function (thumb) {
          if (!thumb) return;
          const preload = new Image();
          preload.src = thumb.dataset.full;
        });
      }
    });
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!drawer || !overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-is-open');
    });
  }

  function closeCart() {
    if (!drawer || !overlay) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-is-open');
    window.setTimeout(function () { overlay.hidden = true; }, 260);
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) { badge.textContent = cart.item_count; });
    const container = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    const total = document.querySelector('[data-cart-total]');
    if (!container) return;
    if (!cart.items.length) {
      container.innerHTML = '<div class="cart-empty"><span>😴</span><p>Your cart is ready for a little more rest.</p></div>';
      if (footer) footer.hidden = true;
      return;
    }
    container.innerHTML = cart.items.map(function (item) {
      const image = item.image ? '<img src="' + escapeHtml(item.image) + '&width=180" width="82" height="82" alt="">' : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '';
      return '<article class="cart-line">' + image + '<div><strong>' + escapeHtml(item.product_title) + '</strong>' + variant + '<small>Qty: ' + item.quantity + '</small><span>' + formatMoney(item.final_line_price) + '</span></div><button class="cart-line__remove" type="button" data-cart-remove="' + escapeHtml(item.key) + '" aria-label="Remove item">×</button></article>';
    }).join('');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (footer) footer.hidden = false;
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart could not be loaded.'); return response.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  document.querySelectorAll('[data-open-cart]').forEach(function (button) {
    button.addEventListener('click', function () { refreshCart().catch(function () {}).finally(openCart); });
  });
  document.querySelectorAll('[data-close-cart]').forEach(function (button) { button.addEventListener('click', closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeCart(); });
  if (drawer) {
    drawer.addEventListener('click', function (event) {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      remove.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
      }).then(function (response) { return response.json(); }).then(renderCart).catch(function () { remove.disabled = false; });
    });
  }

  function optionPrice(select) {
    if (!select) return 0;
    if (select.tagName === 'INPUT') return Number(select.dataset.price || 0);
    const option = select.options[select.selectedIndex];
    return Number(option && option.dataset.price || 0);
  }

  function activeCard(form) {
    const checked = form.querySelector('input[name="bundle"]:checked');
    return checked ? form.querySelector('[data-bundle-card="' + checked.value + '"]') : form.querySelector('[data-bundle-card]');
  }

  function updateBundlePrices(form) {
    const checked = form.querySelector('input[name="bundle"]:checked');
    const mode = checked ? checked.value : 'single';
    const discount = Number(form.dataset.discount || 0);
    const singleSelect = form.querySelector('[data-bundle-card="single"] [data-variant-select]');
    const single = optionPrice(singleSelect);
    const singleOutput = form.querySelector('[data-single-price]');
    if (single && singleOutput) singleOutput.textContent = formatMoney(single);

    const duoSelects = form.querySelectorAll('[data-bundle-card="duo"] [data-variant-select]');
    let duoOriginal = 0;
    duoSelects.forEach(function (select) { duoOriginal += optionPrice(select); });
    const duoPrice = Math.round(duoOriginal * (100 - discount) / 100);
    const duoOutput = form.querySelector('[data-duo-price]');
    const duoCompare = form.querySelector('[data-duo-original]');
    if (duoOriginal && duoOutput) duoOutput.textContent = formatMoney(duoPrice);
    if (duoOriginal && duoCompare) duoCompare.textContent = formatMoney(duoOriginal);

    const section = form.closest('[data-product-section]');
    const sticky = section && section.querySelector('[data-sticky-price]');
    if (sticky && single) sticky.textContent = formatMoney(mode === 'duo' ? duoPrice : single);
  }

  function selectBundle(form, mode) {
    form.querySelectorAll('[data-bundle-card]').forEach(function (card) {
      const selected = card.dataset.bundleCard === mode;
      card.classList.toggle('is-selected', selected);
      card.querySelectorAll('[data-addon]').forEach(function (addon) { addon.disabled = !selected; });
    });
    const quantity = form.querySelector('[data-quantity]');
    if (quantity) quantity.value = mode === 'duo' ? 2 : 1;
    updateBundlePrices(form);
  }

  function selectedItems(form) {
    const card = activeCard(form);
    if (!card) return [];
    const mode = card.dataset.bundleCard;
    const quantityInput = form.querySelector('[data-quantity]');
    const quantity = Math.max(1, Math.min(20, Number(quantityInput && quantityInput.value || 1)));
    const variants = Array.from(card.querySelectorAll('[data-variant-select]')).map(function (select) { return select.value; }).filter(Boolean);
    if (!variants.length) return [];
    const counts = {};
    for (let i = 0; i < quantity; i += 1) {
      const id = mode === 'duo' ? variants[i % variants.length] : variants[0];
      counts[id] = (counts[id] || 0) + 1;
    }
    const items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    card.querySelectorAll('[data-addon]:checked:not(:disabled)').forEach(function (addon) {
      if (/^\d+$/.test(addon.dataset.addon || '')) items.push({ id: Number(addon.dataset.addon), quantity: 1 });
    });
    return items;
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    const label = button.querySelector('[data-button-label]');
    if (label && !button.dataset.defaultText) button.dataset.defaultText = label.textContent;
    button.classList.toggle('is-loading', loading);
    button.disabled = loading || button.closest('form').dataset.productReady !== 'true';
  }

  function showButtonSuccess(button) {
    if (!button) return;
    const label = button.querySelector('[data-button-label]');
    button.classList.remove('is-loading');
    button.classList.add('is-success');
    button.disabled = false;
    if (label) label.textContent = button.dataset.successText || 'DONE ✓';
    window.setTimeout(function () {
      button.classList.remove('is-success');
      if (label && button.dataset.defaultText) label.textContent = button.dataset.defaultText;
    }, 1600);
  }

  function runPurchase(form, button, goToCheckout) {
    const message = form.querySelector('[data-form-message]');
    const items = selectedItems(form);
    if (!items.length || form.dataset.productReady !== 'true') {
      if (message) { message.textContent = 'Choose the homepage product in the Theme Editor first.'; message.classList.add('is-error'); }
      return;
    }
    setButtonLoading(button, true);
    if (message) { message.textContent = ''; message.classList.remove('is-error'); }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.'); return data; });
    }).then(function () {
      showButtonSuccess(button);
      if (message) message.textContent = 'Added to your cart!';
      if (goToCheckout) {
        window.setTimeout(function () { window.location.assign(root + 'checkout'); }, 520);
        return null;
      }
      return refreshCart().then(function () { window.setTimeout(openCart, 520); });
    }).catch(function (error) {
      if (message) { message.textContent = error.message; message.classList.add('is-error'); }
      setButtonLoading(button, false);
    });
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.querySelectorAll('input[name="bundle"]').forEach(function (radio) {
      radio.addEventListener('change', function () { selectBundle(form, radio.value); });
    });
    form.querySelectorAll('[data-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () { updateBundlePrices(form); });
    });
    const minus = form.querySelector('[data-quantity-minus]');
    const plus = form.querySelector('[data-quantity-plus]');
    const quantity = form.querySelector('[data-quantity]');
    if (minus && quantity) minus.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    if (plus && quantity) plus.addEventListener('click', function () { quantity.value = Math.min(20, Number(quantity.value || 1) + 1); });
    if (quantity) quantity.addEventListener('change', function () { quantity.value = Math.max(1, Math.min(20, Number(quantity.value || 1))); });

    selectBundle(form, (form.querySelector('input[name="bundle"]:checked') || {}).value || 'single');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const button = form.querySelector('[data-add-to-cart]');
      runPurchase(form, button, false);
    });

    const buyNow = form.querySelector('[data-buy-now]');
    if (buyNow) buyNow.addEventListener('click', function () { runPurchase(form, buyNow, true); });

    const section = form.closest('[data-product-section]');
    const stickySubmit = section && section.querySelector('[data-sticky-submit]');
    if (stickySubmit) stickySubmit.addEventListener('click', function () { form.requestSubmit(); });
    if (stickySubmit && 'IntersectionObserver' in window) {
      const stickyBar = section.querySelector('[data-mobile-sticky]');
      const mainButton = form.querySelector('[data-add-to-cart]');
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { stickyBar.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 500); });
      }, { threshold: 0.1 });
      if (mainButton) observer.observe(mainButton);
    }
  });

  initCountdowns();
  initGalleries();
})();
